module.exports = __webpack_public_path__ + "img/3.25b35e2a.webp";